import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

// Session lives in an httpOnly cookie set by the backend; nothing auth-related is kept in localStorage.
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data.user);
    return r.data.user;
  };

  const signup = async (email, password, name, uiMode = "beginner") => {
    const r = await api.post("/auth/signup", { email, password, name, ui_mode: uiMode });
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = async (to = "/login") => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("[apex] logout:", e?.message || e); }
    setUser(null);
    window.location.href = to;
  };

  return (
    <AuthCtx.Provider value={{ user, login, signup, logout, loading }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
